// 병원명·주소 다국어 표기. 한국어 원문은 hospitals.ts 를 그대로 쓴다.
// 이름: 음역 규칙 하나로 통일한다(공식 영문명 예외를 두지 않는다).
//   - 예외를 두면 목록의 일관성이 깨지고, 아는 만큼만 정확해진다.
//   - 음역은 환자가 소리 내어 말할 수 있고, 한국어 원문이 바로 아래 붙는다.
// 주소: 로마자 1종을 en·zh·mn 이 공유한다(공식 외국어 표기가 로마자뿐이다).
// 같은 표기가 둘 이상이면 구/군을 덧붙여 구분한다.

export interface HospitalI18nEntry { name: string; address: string; }
export type HospitalI18n = Record<number, { en: HospitalI18nEntry; zh: HospitalI18nEntry; mn: HospitalI18nEntry }>;

export const hospitalI18n: HospitalI18n = {
  1: {
    en: { name: "DMC Joeun Eye Clinic", address: "402 World Cup buk-ro, Mapo-gu, Seoul, 3F" },
    zh: { name: "DMC 祖恩眼科医院", address: "402 World Cup buk-ro, Mapo-gu, Seoul, 3F" },
    mn: { name: "DMC Жоын нүдний эмнэлэг", address: "402 World Cup buk-ro, Mapo-gu, Seoul, 3F" },
  },
  3: {
    en: { name: "Gangnam Eyeones Eye Clinic", address: "368 Sapyeong-daero, Seocho-gu, Seoul, 5-6F" },
    zh: { name: "江南爱旺斯眼科", address: "368 Sapyeong-daero, Seocho-gu, Seoul, 5-6F" },
    mn: { name: "Ганнам Айвонс нүдний эмнэлэг", address: "368 Sapyeong-daero, Seocho-gu, Seoul, 5-6F" },
  },
  4: {
    en: { name: "Gangnam Tokyo Eye Clinic", address: "442 Gangnam-daero, Gangnam-gu, Seoul, 5F" },
    zh: { name: "江南东京眼科", address: "442 Gangnam-daero, Gangnam-gu, Seoul, 5F" },
    mn: { name: "Ганнам Токио нүдний эмнэлэг", address: "442 Gangnam-daero, Gangnam-gu, Seoul, 5F" },
  },
  5: {
    en: { name: "Gangnam Balgeunmyeong Eye Clinic", address: "Seocho4-dong 1305-8, Seocho-gu, Seoul" },
    zh: { name: "江南明亮眼科", address: "Seocho4-dong 1305-8, Seocho-gu, Seoul" },
    mn: { name: "Ганнам Балгынмён нүдний эмнэлэг", address: "Seocho4-dong 1305-8, Seocho-gu, Seoul" },
  },
  6: {
    en: { name: "Gangnam Balgeun Miso Eye Clinic", address: "408 Gangnam-daero, Gangnam-gu, Seoul, 3F" },
    zh: { name: "江南明亮微笑眼科", address: "408 Gangnam-daero, Gangnam-gu, Seoul, 3F" },
    mn: { name: "Ганнам Балгын Мисо нүдний эмнэлэг", address: "408 Gangnam-daero, Gangnam-gu, Seoul, 3F" },
  },
  7: {
    en: { name: "Gangnam Brand Eye Clinic (Incheon Branch)", address: "32 Sijang-ro, Bupyeong-gu, Incheon, 2F" },
    zh: { name: "江南品牌眼科（仁川分院）", address: "32 Sijang-ro, Bupyeong-gu, Incheon, 2F" },
    mn: { name: "Ганнам Бранд нүдний эмнэлэг (Инчон салбар)", address: "32 Sijang-ro, Bupyeong-gu, Incheon, 2F" },
  },
  8: {
    en: { name: "Gangnam Brand Eye Clinic", address: "519 Gangnam-daero, Seocho-gu, Seoul, 3F" },
    zh: { name: "江南品牌眼科医院", address: "519 Gangnam-daero, Seocho-gu, Seoul, 3F" },
    mn: { name: "Ганнам Бранд нүдний эмнэлэг", address: "519 Gangnam-daero, Seocho-gu, Seoul, 3F" },
  },
  9: {
    en: { name: "Gangnam Seoul Balgeun Eye Clinic", address: "390 Gangnam-daero, Gangnam-gu, Seoul, 18F" },
    zh: { name: "江南首尔明亮眼科", address: "390 Gangnam-daero, Gangnam-gu, Seoul, 18F" },
    mn: { name: "Ганнам Сөүл Балгын нүдний эмнэлэг", address: "390 Gangnam-daero, Gangnam-gu, Seoul, 18F" },
  },
  10: {
    en: { name: "Gangnam Seongmowon Eye Clinic", address: "5 Gangnam-daero 85-gil, Seocho-gu, Seoul, 2F" },
    zh: { name: "江南圣母园眼科", address: "5 Gangnam-daero 85-gil, Seocho-gu, Seoul, 2F" },
    mn: { name: "Ганнам Сонмовон нүдний эмнэлэг", address: "5 Gangnam-daero 85-gil, Seocho-gu, Seoul, 2F" },
  },
  11: {
    en: { name: "Gangnam Central Eye Clinic", address: "333 Teheran-ro, Gangnam-gu, Seoul, 8-9F" },
    zh: { name: "江南中央眼科", address: "333 Teheran-ro, Gangnam-gu, Seoul, 8-9F" },
    mn: { name: "Ганнам Централ нүдний эмнэлэг", address: "333 Teheran-ro, Gangnam-gu, Seoul, 8-9F" },
  },
  12: {
    en: { name: "Gangnam IOK Eye Clinic", address: "491 Gangnam-daero, Seocho-gu, Seoul" },
    zh: { name: "江南IOK眼科", address: "491 Gangnam-daero, Seocho-gu, Seoul" },
    mn: { name: "Ганнам IOK нүдний эмнэлэг", address: "491 Gangnam-daero, Seocho-gu, Seoul" },
  },
  13: {
    en: { name: "Gangnam Ace Eye Clinic", address: "151 Teheran-ro, Gangnam-gu, Seoul, 2F" },
    zh: { name: "江南王牌眼科", address: "151 Teheran-ro, Gangnam-gu, Seoul, 2F" },
    mn: { name: "Ганнам Эйс нүдний эмнэлэг", address: "151 Teheran-ro, Gangnam-gu, Seoul, 2F" },
  },
  14: {
    en: { name: "Gangnam Ireum Eye Clinic", address: "358 Gangnam-daero, Gangnam-gu, Seoul, 1F" },
    zh: { name: "江南伊隆眼科", address: "358 Gangnam-daero, Gangnam-gu, Seoul, 1F" },
    mn: { name: "Ганнам Ирум нүдний эмнэлэг", address: "358 Gangnam-daero, Gangnam-gu, Seoul, 1F" },
  },
  15: {
    en: { name: "Gangnam EOS Eye Clinic", address: "355 Gangnam-daero, Seocho-gu, Seoul, 18-20F" },
    zh: { name: "江南EOS眼科", address: "355 Gangnam-daero, Seocho-gu, Seoul, 18-20F" },
    mn: { name: "Ганнам EOS нүдний эмнэлэг", address: "355 Gangnam-daero, Seocho-gu, Seoul, 18-20F" },
  },
  16: {
    en: { name: "Gangnam Cube Eye Clinic", address: "703 Seolleung-ro, Gangnam-gu, Seoul, 6F" },
    zh: { name: "江南立方眼科", address: "703 Seolleung-ro, Gangnam-gu, Seoul, 6F" },
    mn: { name: "Ганнам Кюб нүдний эмнэлэг", address: "703 Seolleung-ro, Gangnam-gu, Seoul, 6F" },
  },
  17: {
    en: { name: "Gongdeok Eye Clinic", address: "14 Mallijae-ro, Mapo-gu, Seoul, 3F" },
    zh: { name: "孔德眼科", address: "14 Mallijae-ro, Mapo-gu, Seoul, 3F" },
    mn: { name: "Гондок нүдний эмнэлэг", address: "14 Mallijae-ro, Mapo-gu, Seoul, 3F" },
  },
  18: {
    en: { name: "Gong Eye Clinic", address: "19 Jong-ro, Jongro-gu, Seoul" },
    zh: { name: "孔眼科", address: "19 Jong-ro, Jongro-gu, Seoul" },
    mn: { name: "Гон нүдний эмнэлэг", address: "19 Jong-ro, Jongro-gu, Seoul" },
  },
  19: {
    en: { name: "Gwanggyo Yonsei Eye Clinic", address: "98 Centraltown-ro, Suwon-si, Yeongtong-gu, Gyeonggi-do" },
    zh: { name: "光教延世眼科", address: "98 Centraltown-ro, Suwon-si, Yeongtong-gu, Gyeonggi-do" },
    mn: { name: "Гванггё Ёнсэ нүдний эмнэлэг", address: "98 Centraltown-ro, Suwon-si, Yeongtong-gu, Gyeonggi-do" },
  },
  20: {
    en: { name: "Gwangju Good Morning Seoul Eye Clinic", address: "965 Mujin-daero, Seo-gu, Gwangju" },
    zh: { name: "光州早安首尔眼科", address: "965 Mujin-daero, Seo-gu, Gwangju" },
    mn: { name: "Гванжу Гүд Морнинг Сөүл нүдний эмнэлэг", address: "965 Mujin-daero, Seo-gu, Gwangju" },
  },
  21: {
    en: { name: "Guri Seongmo Eye Clinic", address: "239 Gyeongchun-ro, Guri-si, Gyeonggi-do, 5F" },
    zh: { name: "九里圣母眼科", address: "239 Gyeongchun-ro, Guri-si, Gyeonggi-do, 5F" },
    mn: { name: "Гүри Сонмо нүдний эмнэлэг", address: "239 Gyeongchun-ro, Guri-si, Gyeonggi-do, 5F" },
  },
  22: {
    en: { name: "Good Morning Baegi Eye Clinic", address: "724 Jungang-daero, Busanjin-gu, Busan, 3F" },
    zh: { name: "早安白怡眼科", address: "724 Jungang-daero, Busanjin-gu, Busan, 3F" },
    mn: { name: "Гүд Морнинг Пэги нүдний эмнэлэг", address: "724 Jungang-daero, Busanjin-gu, Busan, 3F" },
  },
  23: {
    en: { name: "Good Morning Bit Eye Clinic", address: "266 Samsan-ro, Nam-gu, Ulsan, 2-3F" },
    zh: { name: "早安之光眼科", address: "266 Samsan-ro, Nam-gu, Ulsan, 2-3F" },
    mn: { name: "Гүд Морнинг Бит нүдний эмнэлэг", address: "266 Samsan-ro, Nam-gu, Ulsan, 2-3F" },
  },
  24: {
    en: { name: "Good Morning Seongmo Clinic", address: "2 Saessak-ro, Busanjin-gu, Busan" },
    zh: { name: "早安圣母医院", address: "2 Saessak-ro, Busanjin-gu, Busan" },
    mn: { name: "Гүд Морнинг Сонмо эмнэлэг", address: "2 Saessak-ro, Busanjin-gu, Busan" },
  },
  25: {
    en: { name: "Good Morning Eye Clinic", address: "254 Samsan-ro, Nam-gu, Ulsan, 5-6F" },
    zh: { name: "早安眼科", address: "254 Samsan-ro, Nam-gu, Ulsan, 5-6F" },
    mn: { name: "Гүд Морнинг нүдний эмнэлэг", address: "254 Samsan-ro, Nam-gu, Ulsan, 5-6F" },
  },
  26: {
    en: { name: "Grand BS Eye Clinic", address: "664 Jungang-daero, Busanjin-gu, Busan, 3F" },
    zh: { name: "格兰德BS眼科", address: "664 Jungang-daero, Busanjin-gu, Busan, 3F" },
    mn: { name: "Гранд BS нүдний эмнэлэг", address: "664 Jungang-daero, Busanjin-gu, Busan, 3F" },
  },
  27: {
    en: { name: "Global Vision Eye Clinic", address: "1366 Gyeongwon-daero, Bupyeong-gu, Incheon, 9F" },
    zh: { name: "全球视觉眼科医院", address: "1366 Gyeongwon-daero, Bupyeong-gu, Incheon, 9F" },
    mn: { name: "Глобал Вижн нүдний эмнэлэг", address: "1366 Gyeongwon-daero, Bupyeong-gu, Incheon, 9F" },
  },
  28: {
    en: { name: "Kim Eye Hospital", address: "136 Yeongsin-ro, Yeongdeungpo-gu, Seoul" },
    zh: { name: "金眼科医院", address: "136 Yeongsin-ro, Yeongdeungpo-gu, Seoul" },
    mn: { name: "Ким нүдний эмнэлгийн төв", address: "136 Yeongsin-ro, Yeongdeungpo-gu, Seoul" },
  },
  29: {
    en: { name: "Kim Eye Clinic (Masan Hoewon)", address: "669 15-daero, Changwon-si, Masanhoewon-gu, Gyeongsangnam-do" },
    zh: { name: "金眼科医院（马山会原）", address: "669 15-daero, Changwon-si, Masanhoewon-gu, Gyeongsangnam-do" },
    mn: { name: "Ким нүдний эмнэлэг (Масан Хөвон)", address: "669 15-daero, Changwon-si, Masanhoewon-gu, Gyeongsangnam-do" },
  },
  30: {
    en: { name: "Kim Eye Clinic (Pyeongtaek)", address: "270 Jungang-ro, Pyeongtaek-si, Gyeonggi-do" },
    zh: { name: "金眼科医院（平泽）", address: "270 Jungang-ro, Pyeongtaek-si, Gyeonggi-do" },
    mn: { name: "Ким нүдний эмнэлэг (Пёнтэк)", address: "270 Jungang-ro, Pyeongtaek-si, Gyeonggi-do" },
  },
  31: {
    en: { name: "Nancho Kkotpida Eye Clinic", address: "2127 Dalgubeol-daero, Jung-gu, Daegu, 7F" },
    zh: { name: "兰花绽放眼科医院", address: "2127 Dalgubeol-daero, Jung-gu, Daegu, 7F" },
    mn: { name: "Нанчо Ккотпида нүдний эмнэлэг", address: "2127 Dalgubeol-daero, Jung-gu, Daegu, 7F" },
  },
  32: {
    en: { name: "Nune Bit Eye Clinic", address: "77 Bujeon-ro, Busanjin-gu, Busan, 7-13F" },
    zh: { name: "眼中之光眼科", address: "77 Bujeon-ro, Busanjin-gu, Busan, 7-13F" },
    mn: { name: "Нүнэ Бит нүдний эмнэлэг", address: "77 Bujeon-ro, Busanjin-gu, Busan, 7-13F" },
  },
  35: {
    en: { name: "Nunnopi Eye Clinic", address: "130 Samsan-ro, Nam-gu, Ulsan" },
    zh: { name: "眼之高度眼科", address: "130 Samsan-ro, Nam-gu, Ulsan" },
    mn: { name: "Нүннопи нүдний эмнэлэг", address: "130 Samsan-ro, Nam-gu, Ulsan" },
  },
  36: {
    en: { name: "Nunsarang Eye Clinic (Daejeon)", address: "Dunsan2-dong 1166, Seo-gu, Daejeon" },
    zh: { name: "爱眼科（大田）", address: "Dunsan2-dong 1166, Seo-gu, Daejeon" },
    mn: { name: "Нүнсаран нүдний эмнэлэг (Тэжон)", address: "Dunsan2-dong 1166, Seo-gu, Daejeon" },
  },
  37: {
    en: { name: "Nun Siwon Eye Clinic", address: "186 Beomil-ro, Busanjin-gu, Busan, 4F" },
    zh: { name: "明眸眼科", address: "186 Beomil-ro, Busanjin-gu, Busan, 4F" },
    mn: { name: "Нүн Шивон нүдний эмнэлэг", address: "186 Beomil-ro, Busanjin-gu, Busan, 4F" },
  },
  38: {
    en: { name: "Nunae Eye Clinic", address: "241 Achasan-ro, Gwangjin-gu, Seoul" },
    zh: { name: "眼爱眼科医院", address: "241 Achasan-ro, Gwangjin-gu, Seoul" },
    mn: { name: "Нүнэ нүдний эмнэлэг", address: "241 Achasan-ro, Gwangjin-gu, Seoul" },
  },
  39: {
    en: { name: "Nune Miso Eye Clinic", address: "364 Gangnam-daero, Gangnam-gu, Seoul, 3F" },
    zh: { name: "眼中微笑眼科", address: "364 Gangnam-daero, Gangnam-gu, Seoul, 3F" },
    mn: { name: "Нүнэ Мисо нүдний эмнэлэг", address: "364 Gangnam-daero, Gangnam-gu, Seoul, 3F" },
  },
  40: {
    en: { name: "Nune Him Eye Clinic", address: "551 Siheung-daero, Guro-gu, Seoul, 5F" },
    zh: { name: "眼之力眼科", address: "551 Siheung-daero, Guro-gu, Seoul, 5F" },
    mn: { name: "Нүнэ Хим нүдний эмнэлэг", address: "551 Siheung-daero, Guro-gu, Seoul, 5F" },
  },
  41: {
    en: { name: "Dabom Eye Clinic", address: "783 Gaya-daero, Busanjin-gu, Busan, 5F" },
    zh: { name: "多春眼科", address: "783 Gaya-daero, Busanjin-gu, Busan, 5F" },
    mn: { name: "Дабом нүдний эмнэлэг", address: "783 Gaya-daero, Busanjin-gu, Busan, 5F" },
  },
  42: {
    en: { name: "Daegu Eye Clinic", address: "468 Wolbae-ro, Nam-gu, Daegu" },
    zh: { name: "大邱眼科医院", address: "468 Wolbae-ro, Nam-gu, Daegu" },
    mn: { name: "Тэгү нүдний эмнэлэг", address: "468 Wolbae-ro, Nam-gu, Daegu" },
  },
  43: {
    en: { name: "Daegu Yonsei Eye Clinic", address: "206 Suseong-ro, Suseong-gu, Daegu" },
    zh: { name: "大邱延世眼科", address: "206 Suseong-ro, Suseong-gu, Daegu" },
    mn: { name: "Тэгү Ёнсэ нүдний эмнэлэг", address: "206 Suseong-ro, Suseong-gu, Daegu" },
  },
  44: {
    en: { name: "Daejeon Seongmo Eye Clinic", address: "599 Gyeryong-ro, Seo-gu, Daejeon" },
    zh: { name: "大田圣母眼科", address: "599 Gyeryong-ro, Seo-gu, Daejeon" },
    mn: { name: "Тэжон Сонмо нүдний эмнэлэг", address: "599 Gyeryong-ro, Seo-gu, Daejeon" },
  },
  45: {
    en: { name: "The Cham Eye Clinic", address: "708 Jungang-daero, Busanjin-gu, Busan, 8F" },
    zh: { name: "The 真眼科", address: "708 Jungang-daero, Busanjin-gu, Busan, 8F" },
    mn: { name: "The Чам нүдний эмнэлэг", address: "708 Jungang-daero, Busanjin-gu, Busan, 8F" },
  },
  46: {
    en: { name: "Demian Eye Clinic", address: "29 Byeongjeom-noeul 4-ro, Hwaseong-si, Gyeonggi-do, 5F" },
    zh: { name: "德米安眼科", address: "29 Byeongjeom-noeul 4-ro, Hwaseong-si, Gyeonggi-do, 5F" },
    mn: { name: "Демиан нүдний эмнэлэг", address: "29 Byeongjeom-noeul 4-ro, Hwaseong-si, Gyeonggi-do, 5F" },
  },
  47: {
    en: { name: "Dream Seongmo Eye Clinic", address: "390 Gangnam-daero, Gangnam-gu, Seoul, 14F" },
    zh: { name: "梦想圣母眼科", address: "390 Gangnam-daero, Gangnam-gu, Seoul, 14F" },
    mn: { name: "Дрийм Сонмо нүдний эмнэлэг", address: "390 Gangnam-daero, Gangnam-gu, Seoul, 14F" },
  },
  48: {
    en: { name: "Roun Eye Clinic", address: "260 Wolgok-ro, Dalseo-gu, Daegu, 3F" },
    zh: { name: "路云眼科医院", address: "260 Wolgok-ro, Dalseo-gu, Daegu, 3F" },
    mn: { name: "Роун нүдний эмнэлэг", address: "260 Wolgok-ro, Dalseo-gu, Daegu, 3F" },
  },
  49: {
    en: { name: "Luwon Smile Eye Clinic", address: "451 Gajeong-ro, Seo-gu, Incheon, 8F" },
    zh: { name: "楼院微笑眼科医院", address: "451 Gajeong-ro, Seo-gu, Incheon, 8F" },
    mn: { name: "Лүвон Смайл нүдний эмнэлэг", address: "451 Gajeong-ro, Seo-gu, Incheon, 8F" },
  },
  50: {
    en: { name: "Rijian Eye Clinic", address: "68 Dolma-ro, Seongnam-si, Gyeonggi-do, 3F" },
    zh: { name: "丽志安眼科", address: "68 Dolma-ro, Seongnam-si, Gyeonggi-do, 3F" },
    mn: { name: "Рижиан нүдний эмнэлэг", address: "68 Dolma-ro, Seongnam-si, Gyeonggi-do, 3F" },
  },
  51: {
    en: { name: "Malgeun Nun Eye Clinic", address: "148 Cheongsa-ro, Seo-gu, Daejeon, 1F" },
    zh: { name: "清澈之眼科医院", address: "148 Cheongsa-ro, Seo-gu, Daejeon, 1F" },
    mn: { name: "Малгын Нүн нүдний эмнэлэг", address: "148 Cheongsa-ro, Seo-gu, Daejeon, 1F" },
  },
  52: {
    en: { name: "Metro Eye Clinic (Daegu)", address: "2360 Dalgubeol-daero, Suseong-gu, Daegu" },
    zh: { name: "美特罗眼科（大邱）", address: "2360 Dalgubeol-daero, Suseong-gu, Daegu" },
    mn: { name: "Метро нүдний эмнэлэг (Тэгү)", address: "2360 Dalgubeol-daero, Suseong-gu, Daegu" },
  },
  53: {
    en: { name: "Myeongdong Seongmo Eye Clinic", address: "2 Eulji-ro, Jung-gu, Seoul" },
    zh: { name: "明洞圣母眼科", address: "2 Eulji-ro, Jung-gu, Seoul" },
    mn: { name: "Мёндон Сонмо нүдний эмнэлэг", address: "2 Eulji-ro, Jung-gu, Seoul" },
  },
  54: {
    en: { name: "Moon Eye Clinic", address: "762 Jeongjo-ro, Suwon-si, Paldal-gu, Gyeonggi-do" },
    zh: { name: "文眼科", address: "762 Jeongjo-ro, Suwon-si, Paldal-gu, Gyeonggi-do" },
    mn: { name: "Мун нүдний эмнэлэг", address: "762 Jeongjo-ro, Suwon-si, Paldal-gu, Gyeonggi-do" },
  },
  55: {
    en: { name: "Balgeun Nuri Eye Hospital", address: "61 Dunsan-ro, Seo-gu, Daejeon" },
    zh: { name: "明亮天地眼科医院", address: "61 Dunsan-ro, Seo-gu, Daejeon" },
    mn: { name: "Балгын Нүри нүдний эмнэлгийн төв", address: "61 Dunsan-ro, Seo-gu, Daejeon" },
  },
  56: {
    en: { name: "Balgeun Nun Eye Hospital", address: "729 Gaya-daero, Busanjin-gu, Busan" },
    zh: { name: "明亮双眸眼科医院", address: "729 Gaya-daero, Busanjin-gu, Busan" },
    mn: { name: "Балгын Нүн нүдний эмнэлгийн төв", address: "729 Gaya-daero, Busanjin-gu, Busan" },
  },
  57: {
    en: { name: "Balgeun Nun Eye Clinic (Jamsil Branch)", address: "300 Olympic-ro, Songpa-gu, Seoul, 11F" },
    zh: { name: "明亮双眸眼科医院（蚕室分院）", address: "300 Olympic-ro, Songpa-gu, Seoul, 11F" },
    mn: { name: "Балгын Нүн нүдний эмнэлэг (Жамшил салбар)", address: "300 Olympic-ro, Songpa-gu, Seoul, 11F" },
  },
  58: {
    en: { name: "Balgeun Seongmo Eye Clinic", address: "110 Teheran-ro, Gangnam-gu, Seoul, 16-18F" },
    zh: { name: "明亮圣母眼科医院", address: "110 Teheran-ro, Gangnam-gu, Seoul, 16-18F" },
    mn: { name: "Балгын Сонмо нүдний эмнэлэг", address: "110 Teheran-ro, Gangnam-gu, Seoul, 16-18F" },
  },
  59: {
    en: { name: "Balgeun Seongmo Eye Clinic (Busan)", address: "723 Jungang-daero, Busanjin-gu, Busan, 5-6F" },
    zh: { name: "明亮圣母眼科医院（釜山）", address: "723 Jungang-daero, Busanjin-gu, Busan, 5-6F" },
    mn: { name: "Балгын Сонмо нүдний эмнэлэг (Пусан)", address: "723 Jungang-daero, Busanjin-gu, Busan, 5-6F" },
  },
  60: {
    en: { name: "Balgeun Sesang Eye Clinic (Busan)", address: "74 Seomyeon-ro, Busanjin-gu, Busan, 8-11F" },
    zh: { name: "明亮世界眼科（釜山）", address: "74 Seomyeon-ro, Busanjin-gu, Busan, 8-11F" },
    mn: { name: "Балгын Сэсан нүдний эмнэлэг (Пусан)", address: "74 Seomyeon-ro, Busanjin-gu, Busan, 8-11F" },
  },
  61: {
    en: { name: "Balgeun Sesang Eye Clinic (Seoul)", address: "823 Seolleung-ro, Gangnam-gu, Seoul, 7F" },
    zh: { name: "明亮世界眼科医院（首尔）", address: "823 Seolleung-ro, Gangnam-gu, Seoul, 7F" },
    mn: { name: "Балгын Сэсан нүдний эмнэлэг (Сөүл)", address: "823 Seolleung-ro, Gangnam-gu, Seoul, 7F" },
  },
  62: {
    en: { name: "Balgeun Su Eye Clinic", address: "781-1 Gaya-daero, Busanjin-gu, Busan, 8-9F" },
    zh: { name: "明亮秀眼科医院", address: "781-1 Gaya-daero, Busanjin-gu, Busan, 8-9F" },
    mn: { name: "Балгын Сү нүдний эмнэлэг", address: "781-1 Gaya-daero, Busanjin-gu, Busan, 8-9F" },
  },
  63: {
    en: { name: "Balgeun Eye Clinic (Gyeongsan)", address: "17 Jungbang-ro, Gyeongsan-si, Gyeongsangbuk-do, 4F" },
    zh: { name: "明亮眼科（庆山）", address: "17 Jungbang-ro, Gyeongsan-si, Gyeongsangbuk-do, 4F" },
    mn: { name: "Балгын нүдний эмнэлэг (Гёнсан)", address: "17 Jungbang-ro, Gyeongsan-si, Gyeongsangbuk-do, 4F" },
  },
  64: {
    en: { name: "Balgeun Healing Eye Clinic", address: "126 Sangnam-ro, Changwon-si, Seongsan-gu, Gyeongsangnam-do, 10F" },
    zh: { name: "明亮疗愈眼科医院", address: "126 Sangnam-ro, Changwon-si, Seongsan-gu, Gyeongsangnam-do, 10F" },
    mn: { name: "Балгын Хийлин нүдний эмнэлэг", address: "126 Sangnam-ro, Changwon-si, Seongsan-gu, Gyeongsangnam-do, 10F" },
  },
  65: {
    en: { name: "Balgeum Nanum Eye Clinic (Gangnam)", address: "376 Gangnam-daero, Gangnam-gu, Seoul, 14F" },
    zh: { name: "明亮分享眼科（강남）", address: "376 Gangnam-daero, Gangnam-gu, Seoul, 14F" },
    mn: { name: "Балгым Нанум нүдний эмнэлэг (Gangnam)", address: "376 Gangnam-daero, Gangnam-gu, Seoul, 14F" },
  },
  66: {
    en: { name: "Balgeum Nanum Eye Clinic (Bucheon)", address: "280 Gilju-ro, Bucheon-si, Wonmi-gu, Gyeonggi-do" },
    zh: { name: "明亮分享眼科（富川）", address: "280 Gilju-ro, Bucheon-si, Wonmi-gu, Gyeonggi-do" },
    mn: { name: "Балгым Нанум нүдний эмнэлэг (Пучон)", address: "280 Gilju-ro, Bucheon-si, Wonmi-gu, Gyeonggi-do" },
  },
  67: {
    en: { name: "Balgeum Nanum Eye Clinic (Anyang Branch)", address: "307 Anyang-ro, Anyang-si, Manan-gu, Gyeonggi-do, 7-8F" },
    zh: { name: "明亮分享眼科（安养分院）", address: "307 Anyang-ro, Anyang-si, Manan-gu, Gyeonggi-do, 7-8F" },
    mn: { name: "Балгым Нанум нүдний эмнэлэг (Анян салбар)", address: "307 Anyang-ro, Anyang-si, Manan-gu, Gyeonggi-do, 7-8F" },
  },
  68: {
    en: { name: "Boda Eye Clinic (Daejeon)", address: "50 Dunsanjung-ro, Seo-gu, Daejeon, 5F" },
    zh: { name: "看见眼科（大田）", address: "50 Dunsanjung-ro, Seo-gu, Daejeon, 5F" },
    mn: { name: "Бода нүдний эмнэлэг (Тэжон)", address: "50 Dunsanjung-ro, Seo-gu, Daejeon, 5F" },
  },
  69: {
    en: { name: "Bomui Yaksok Eye Clinic", address: "1570 Yangjae-daero, Gangdong-gu, Seoul, 5F" },
    zh: { name: "春之约眼科", address: "1570 Yangjae-daero, Gangdong-gu, Seoul, 5F" },
    mn: { name: "Бомый Яксок нүдний эмнэлэг", address: "1570 Yangjae-daero, Gangdong-gu, Seoul, 5F" },
  },
  70: {
    en: { name: "Bomi Oneun Eye Clinic", address: "98 Techno-sangeop-ro, Dalseong-gun, Daegu" },
    zh: { name: "春来眼科医院", address: "98 Techno-sangeop-ro, Dalseong-gun, Daegu" },
    mn: { name: "Боми Онын нүдний эмнэлэг", address: "98 Techno-sangeop-ro, Dalseong-gun, Daegu" },
  },
  71: {
    en: { name: "Busan Seongmo Eye Hospital", address: "409 Haeundae-ro, Haeundae-gu, Busan" },
    zh: { name: "釜山圣母眼科医院", address: "409 Haeundae-ro, Haeundae-gu, Busan" },
    mn: { name: "Пусан Сонмо нүдний эмнэлгийн төв", address: "409 Haeundae-ro, Haeundae-gu, Busan" },
  },
  72: {
    en: { name: "Busan Haneul Eye Clinic", address: "736 Jungang-daero, Busanjin-gu, Busan, 5F" },
    zh: { name: "釜山天空眼科", address: "736 Jungang-daero, Busanjin-gu, Busan, 5F" },
    mn: { name: "Пусан Ханыл нүдний эмнэлэг", address: "736 Jungang-daero, Busanjin-gu, Busan, 5F" },
  },
  73: {
    en: { name: "Bupyeong Dream Eye Clinic", address: "1397 Gyeongwon-daero, Bupyeong-gu, Incheon" },
    zh: { name: "富平梦想眼科", address: "1397 Gyeongwon-daero, Bupyeong-gu, Incheon" },
    mn: { name: "Пупён Дрийм нүдний эмнэлэг", address: "1397 Gyeongwon-daero, Bupyeong-gu, Incheon" },
  },
  74: {
    en: { name: "Bupyeong Seongmo Eye Clinic", address: "1373 Gyeongwon-daero, Bupyeong-gu, Incheon, 4F" },
    zh: { name: "富平圣母眼科", address: "1373 Gyeongwon-daero, Bupyeong-gu, Incheon, 4F" },
    mn: { name: "Пупён Сонмо нүдний эмнэлэг", address: "1373 Gyeongwon-daero, Bupyeong-gu, Incheon, 4F" },
  },
  75: {
    en: { name: "Bupyeong Yeollin Eye Clinic", address: "623 Gilju-ro, Bupyeong-gu, Incheon, 3F" },
    zh: { name: "富平开放眼科医院", address: "623 Gilju-ro, Bupyeong-gu, Incheon, 3F" },
    mn: { name: "Пупён Ёллин нүдний эмнэлэг", address: "623 Gilju-ro, Bupyeong-gu, Incheon, 3F" },
  },
  76: {
    en: { name: "Vista Eye Clinic", address: "505 Jwadongsunhwan-ro, Haeundae-gu, Busan, 11F" },
    zh: { name: "维斯塔眼科", address: "505 Jwadongsunhwan-ro, Haeundae-gu, Busan, 11F" },
    mn: { name: "Виста нүдний эмнэлэг", address: "505 Jwadongsunhwan-ro, Haeundae-gu, Busan, 11F" },
  },
  77: {
    en: { name: "B&VIIT Eye Clinic", address: "411 Seocho-daero, Seocho-gu, Seoul, 2F" },
    zh: { name: "B&VIIT眼科", address: "411 Seocho-daero, Seocho-gu, Seoul, 2F" },
    mn: { name: "B&VIIT нүдний эмнэлэг", address: "411 Seocho-daero, Seocho-gu, Seoul, 2F" },
  },
  78: {
    en: { name: "Bitsarang Eye Clinic", address: "93 Sinchon-ro, Seodaemun-gu, Seoul, 2F" },
    zh: { name: "爱光眼科医院", address: "93 Sinchon-ro, Seodaemun-gu, Seoul, 2F" },
    mn: { name: "Битсаран нүдний эмнэлэг", address: "93 Sinchon-ro, Seodaemun-gu, Seoul, 2F" },
  },
  79: {
    en: { name: "Samsung Miracle Eye Clinic", address: "115 Teheran-ro, Gangnam-gu, Seoul, 7F" },
    zh: { name: "三星奇迹眼科", address: "115 Teheran-ro, Gangnam-gu, Seoul, 7F" },
    mn: { name: "Самсун Миракл нүдний эмнэлэг", address: "115 Teheran-ro, Gangnam-gu, Seoul, 7F" },
  },
  80: {
    en: { name: "Samsung Miracle Eye Clinic (Cheonan)", address: "125 Chungmu-ro, Cheonan-si, Seobuk-gu, Chungcheongnam-do" },
    zh: { name: "三星奇迹眼科（天安）", address: "125 Chungmu-ro, Cheonan-si, Seobuk-gu, Chungcheongnam-do" },
    mn: { name: "Самсун Миракл нүдний эмнэлэг (Чонан)", address: "125 Chungmu-ro, Cheonan-si, Seobuk-gu, Chungcheongnam-do" },
  },
  81: {
    en: { name: "Samsung Smile Eye Clinic", address: "203 Daedeok-daero, Seo-gu, Daejeon, 10F" },
    zh: { name: "三星微笑眼科", address: "203 Daedeok-daero, Seo-gu, Daejeon, 10F" },
    mn: { name: "Самсун Смайл нүдний эмнэлэг", address: "203 Daedeok-daero, Seo-gu, Daejeon, 10F" },
  },
  82: {
    en: { name: "Samsung Eye Clinic (Gangnam-gu)", address: "105 Teheran-ro, Gangnam-gu, Seoul" },
    zh: { name: "三星眼科医院", address: "105 Teheran-ro, Gangnam-gu, Seoul" },
    mn: { name: "Самсун Ай нүдний эмнэлэг", address: "105 Teheran-ro, Gangnam-gu, Seoul" },
  },
  83: {
    en: { name: "Samsung Eye Clinic (Songpa-gu)", address: "114 Olympic-ro, Songpa-gu, Seoul, 7F" },
    zh: { name: "三星眼科", address: "114 Olympic-ro, Songpa-gu, Seoul, 7F" },
    mn: { name: "Самсун нүдний эмнэлэг", address: "114 Olympic-ro, Songpa-gu, Seoul, 7F" },
  },
  84: {
    en: { name: "Samsung Eye Clinic (Sanbon)", address: "15 Sanbon-ro 323beon-gil, Gunpo-si, Gyeonggi-do" },
    zh: { name: "三星眼科（山本）", address: "15 Sanbon-ro 323beon-gil, Gunpo-si, Gyeonggi-do" },
    mn: { name: "Самсун нүдний эмнэлэг (Санбон)", address: "15 Sanbon-ro 323beon-gil, Gunpo-si, Gyeonggi-do" },
  },
  85: {
    en: { name: "Saebit Eye Hospital", address: "1065 Jungang-ro, Goyang-si, Ilsandong-gu, Gyeonggi-do" },
    zh: { name: "新光眼科医院", address: "1065 Jungang-ro, Goyang-si, Ilsandong-gu, Gyeonggi-do" },
    mn: { name: "Сэбит нүдний эмнэлгийн төв", address: "1065 Jungang-ro, Goyang-si, Ilsandong-gu, Gyeonggi-do" },
  },
  86: {
    en: { name: "Saeyan Eye Clinic", address: "395 Samil-daero, Jongro-gu, Seoul, 3F" },
    zh: { name: "赛燕眼科", address: "395 Samil-daero, Jongro-gu, Seoul, 3F" },
    mn: { name: "Сэян нүдний эмнэлэг", address: "395 Samil-daero, Jongro-gu, Seoul, 3F" },
  },
  87: {
    en: { name: "Seomyeon Joeun Saram Eye Clinic", address: "10 Seomyeonmunhwa-ro, Busanjin-gu, Busan, 15-16F" },
    zh: { name: "西面好人眼科", address: "10 Seomyeonmunhwa-ro, Busanjin-gu, Busan, 15-16F" },
    mn: { name: "Сомён Жоын Сарам нүдний эмнэлэг", address: "10 Seomyeonmunhwa-ro, Busanjin-gu, Busan, 15-16F" },
  },
  88: {
    en: { name: "Seo-Busan Seongmo Eye Clinic", address: "1417 Nakdongnam-ro, Saha-gu, Busan, 8F" },
    zh: { name: "西釜山圣母眼科", address: "1417 Nakdongnam-ro, Saha-gu, Busan, 8F" },
    mn: { name: "Со-Пусан Сонмо нүдний эмнэлэг", address: "1417 Nakdongnam-ro, Saha-gu, Busan, 8F" },
  },
  89: {
    en: { name: "Seoul Glow Eye Clinic", address: "507 Nohae-ro, Nowon-gu, Seoul, 3F" },
    zh: { name: "首尔光辉眼科", address: "507 Nohae-ro, Nowon-gu, Seoul, 3F" },
    mn: { name: "Сөүл Глоу нүдний эмнэлэг", address: "507 Nohae-ro, Nowon-gu, Seoul, 3F" },
  },
  90: {
    en: { name: "Seoul Samsung Eye Clinic (Gwangjin-gu)", address: "670 Cheonho-daero, Gwangjin-gu, Seoul" },
    zh: { name: "首尔三星眼科", address: "670 Cheonho-daero, Gwangjin-gu, Seoul" },
    mn: { name: "Сөүл Самсун нүдний эмнэлэг (Гванжин-гү)", address: "670 Cheonho-daero, Gwangjin-gu, Seoul" },
  },
  91: {
    en: { name: "Seoul Samsung Eye Clinic (Gangnam-gu)", address: "Cheongdam-dong 80-4, Gangnam-gu, Seoul" },
    zh: { name: "首尔三星眼科医院", address: "Cheongdam-dong 80-4, Gangnam-gu, Seoul" },
    mn: { name: "Сөүл Самсун нүдний эмнэлэг (Ганнам-гү)", address: "Cheongdam-dong 80-4, Gangnam-gu, Seoul" },
  },
  92: {
    en: { name: "Seoul Shinsegae Eye Clinic", address: "55 Taepyeong-ro 73beon-gil, Uijeongbu-si, Gyeonggi-do, 1F" },
    zh: { name: "首尔新世界眼科", address: "55 Taepyeong-ro 73beon-gil, Uijeongbu-si, Gyeonggi-do, 1F" },
    mn: { name: "Сөүл Шинсэгэ нүдний эмнэлэг", address: "55 Taepyeong-ro 73beon-gil, Uijeongbu-si, Gyeonggi-do, 1F" },
  },
  93: {
    en: { name: "Seoul Shinsegae Eye Clinic (Mia Branch)", address: "52 Dobong-ro, Gangbuk-gu, Seoul, 3-4F" },
    zh: { name: "首尔新世界眼科（弥阿分院）", address: "52 Dobong-ro, Gangbuk-gu, Seoul, 3-4F" },
    mn: { name: "Сөүл Шинсэгэ нүдний эмнэлэг (Миа салбар)", address: "52 Dobong-ro, Gangbuk-gu, Seoul, 3-4F" },
  },
  94: {
    en: { name: "Seoul IVY Eye Clinic (Changwon)", address: "73 Sangnam-ro, Changwon-si, Seongsan-gu, Gyeongsangnam-do, 4F" },
    zh: { name: "首尔常春藤眼科（昌原）", address: "73 Sangnam-ro, Changwon-si, Seongsan-gu, Gyeongsangnam-do, 4F" },
    mn: { name: "Сөүл Айви нүдний эмнэлэг (Чанвон)", address: "73 Sangnam-ro, Changwon-si, Seongsan-gu, Gyeongsangnam-do, 4F" },
  },
  95: {
    en: { name: "Seoul On Eye Clinic", address: "750 Tongil-ro, Eunpyeong-gu, Seoul, 3-4F" },
    zh: { name: "首尔温眼科医院", address: "750 Tongil-ro, Eunpyeong-gu, Seoul, 3-4F" },
    mn: { name: "Сөүл Он нүдний эмнэлэг", address: "750 Tongil-ro, Eunpyeong-gu, Seoul, 3-4F" },
  },
  96: {
    en: { name: "Seochang Balgeun Eye Clinic", address: "223 Seochangnamsunhwan-ro, Namdong-gu, Incheon" },
    zh: { name: "西仓明亮眼科", address: "223 Seochangnamsunhwan-ro, Namdong-gu, Incheon" },
    mn: { name: "Сочан Балгын нүдний эмнэлэг", address: "223 Seochangnamsunhwan-ro, Namdong-gu, Incheon" },
  },
  97: {
    en: { name: "Seongnam Central Eye Clinic", address: "267 Sanseong-daero, Seongnam-si, Sujeong-gu, Gyeonggi-do, 4F" },
    zh: { name: "城南中央眼科", address: "267 Sanseong-daero, Seongnam-si, Sujeong-gu, Gyeonggi-do, 4F" },
    mn: { name: "Соннам Централ нүдний эмнэлэг", address: "267 Sanseong-daero, Seongnam-si, Sujeong-gu, Gyeonggi-do, 4F" },
  },
  98: {
    en: { name: "Seongmojin Eye Clinic", address: "337 Gangnam-daero, Seocho-gu, Seoul, 5F" },
    zh: { name: "圣母真眼科", address: "337 Gangnam-daero, Seocho-gu, Seoul, 5F" },
    mn: { name: "Сонможин нүдний эмнэлэг", address: "337 Gangnam-daero, Seocho-gu, Seoul, 5F" },
  },
  99: {
    en: { name: "Seran Eye Clinic", address: "29 Teheran-ro 87-gil, Gangnam-gu, Seoul, 2F" },
    zh: { name: "世兰眼科", address: "29 Teheran-ro 87-gil, Gangnam-gu, Seoul, 2F" },
    mn: { name: "Серан нүдний эмнэлэг", address: "29 Teheran-ro 87-gil, Gangnam-gu, Seoul, 2F" },
  },
  100: {
    en: { name: "Sejong Uri Seongmo Eye Clinic", address: "273 Hannuri-daero, Sejong, 6F" },
    zh: { name: "世宗我们圣母眼科", address: "273 Hannuri-daero, Sejong, 6F" },
    mn: { name: "Сежон Ури Сонмо нүдний эмнэлэг", address: "273 Hannuri-daero, Sejong, 6F" },
  },
  101: {
    en: { name: "Centum Sojunghan Nun Eye Clinic", address: "50 Centumnam-daero, Haeundae-gu, Busan, 14F" },
    zh: { name: "Centum 珍贵之眼科", address: "50 Centumnam-daero, Haeundae-gu, Busan, 14F" },
    mn: { name: "Центум Сожунхан Нүн нүдний эмнэлэг", address: "50 Centumnam-daero, Haeundae-gu, Busan, 14F" },
  },
  102: {
    en: { name: "Central Gangnam Seongmo Eye Clinic", address: "1360 Yangjae-daero, Gangdong-gu, Seoul, 2F" },
    zh: { name: "中央江南圣母眼科医院", address: "1360 Yangjae-daero, Gangdong-gu, Seoul, 2F" },
    mn: { name: "Централ Ганнам Сонмо нүдний эмнэлэг", address: "1360 Yangjae-daero, Gangdong-gu, Seoul, 2F" },
  },
  103: {
    en: { name: "Central Seoul Eye Clinic", address: "224 Ichon-ro, Yongsan-gu, Seoul, 2F" },
    zh: { name: "中央首尔眼科医院", address: "224 Ichon-ro, Yongsan-gu, Seoul, 2F" },
    mn: { name: "Централ Сөүл нүдний эмнэлэг", address: "224 Ichon-ro, Yongsan-gu, Seoul, 2F" },
  },
  104: {
    en: { name: "Celluble 153 Gangnam", address: "720 Eonju-ro, Gangnam-gu, Seoul, 1F" },
    zh: { name: "Celluble 153 江南", address: "720 Eonju-ro, Gangnam-gu, Seoul, 1F" },
    mn: { name: "Селлюбл 153 Ганнам", address: "720 Eonju-ro, Gangnam-gu, Seoul, 1F" },
  },
  105: {
    en: { name: "Su Eye Clinic", address: "245 Dobong-ro, Gangbuk-gu, Seoul, 2-3F" },
    zh: { name: "秀眼科", address: "245 Dobong-ro, Gangbuk-gu, Seoul, 2-3F" },
    mn: { name: "Сү нүдний эмнэлэг", address: "245 Dobong-ro, Gangbuk-gu, Seoul, 2-3F" },
  },
  106: {
    en: { name: "Su Yonsei Eye Clinic", address: "54 Seocho-daero 77-gil, Seocho-gu, Seoul, 5F" },
    zh: { name: "秀延世眼科医院", address: "54 Seocho-daero 77-gil, Seocho-gu, Seoul, 5F" },
    mn: { name: "Сү Ёнсэ нүдний эмнэлэг", address: "54 Seocho-daero 77-gil, Seocho-gu, Seoul, 5F" },
  },
  107: {
    en: { name: "Sujeong Eye Clinic", address: "5 Mandeok-daero, Buk-gu, Busan" },
    zh: { name: "水晶眼科", address: "5 Mandeok-daero, Buk-gu, Busan" },
    mn: { name: "Сүжон нүдний эмнэлэг", address: "5 Mandeok-daero, Buk-gu, Busan" },
  },
  108: {
    en: { name: "Siheung Seoul Eye Clinic", address: "3362 Suin-ro, Siheung-si, Gyeonggi-do, 7F" },
    zh: { name: "始兴首尔眼科", address: "3362 Suin-ro, Siheung-si, Gyeonggi-do, 7F" },
    mn: { name: "Шихын Сөүл нүдний эмнэлэг", address: "3362 Suin-ro, Siheung-si, Gyeonggi-do, 7F" },
  },
  109: {
    en: { name: "Shinsegae Eye Clinic (Daegu)", address: "311 Dongdaegu-ro, Suseong-gu, Daegu, 7F" },
    zh: { name: "新世界眼科（大邱）", address: "311 Dongdaegu-ro, Suseong-gu, Daegu, 7F" },
    mn: { name: "Шинсэгэ нүдний эмнэлэг (Тэгү)", address: "311 Dongdaegu-ro, Suseong-gu, Daegu, 7F" },
  },
  110: {
    en: { name: "Shinsegae Eye Clinic (Ulsan)", address: "285 Samsan-ro, Nam-gu, Ulsan" },
    zh: { name: "新世界眼科（蔚山）", address: "285 Samsan-ro, Nam-gu, Ulsan" },
    mn: { name: "Шинсэгэ нүдний эмнэлэг (Үлсан)", address: "285 Samsan-ro, Nam-gu, Ulsan" },
  },
  111: {
    en: { name: "Shinsegae Eye Clinic (Busan)", address: "783-1 Gaya-daero, Busanjin-gu, Busan, 3F" },
    zh: { name: "新世界眼科医院（釜山）", address: "783-1 Gaya-daero, Busanjin-gu, Busan, 3F" },
    mn: { name: "Шинсэгэ нүдний эмнэлэг (Пусан)", address: "783-1 Gaya-daero, Busanjin-gu, Busan, 3F" },
  },
  112: {
    en: { name: "Siloam Eye Hospital", address: "181 Deungchon-ro, Gangseo-gu, Seoul" },
    zh: { name: "西罗亚眼科医院", address: "181 Deungchon-ro, Gangseo-gu, Seoul" },
    mn: { name: "Силоам нүдний эмнэлгийн төв", address: "181 Deungchon-ro, Gangseo-gu, Seoul" },
  },
  113: {
    en: { name: "Shim Eye Clinic", address: "218 Wolbae-ro, Dalseo-gu, Daegu, 6F" },
    zh: { name: "沈眼科", address: "218 Wolbae-ro, Dalseo-gu, Daegu, 6F" },
    mn: { name: "Шим нүдний эмнэлэг", address: "218 Wolbae-ro, Dalseo-gu, Daegu, 6F" },
  },
  114: {
    en: { name: "CL Eye Clinic", address: "2105 Dalgubeol-daero, Jung-gu, Daegu, 7F" },
    zh: { name: "CL眼科医院", address: "2105 Dalgubeol-daero, Jung-gu, Daegu, 7F" },
    mn: { name: "CL нүдний эмнэлэг", address: "2105 Dalgubeol-daero, Jung-gu, Daegu, 7F" },
  },
  115: {
    en: { name: "Eyenic Eye Clinic", address: "194 Jeoljae-ro, Sejong" },
    zh: { name: "爱尼克眼科医院", address: "194 Jeoljae-ro, Sejong" },
    mn: { name: "Айник нүдний эмнэлэг", address: "194 Jeoljae-ro, Sejong" },
  },
  116: {
    en: { name: "Eye Love Eye Clinic", address: "30 Apgujeong-ro 32-gil, Gangnam-gu, Seoul" },
    zh: { name: "爱视眼科医院", address: "30 Apgujeong-ro 32-gil, Gangnam-gu, Seoul" },
    mn: { name: "Ай Лав нүдний эмнэлэг", address: "30 Apgujeong-ro 32-gil, Gangnam-gu, Seoul" },
  },
  117: {
    en: { name: "Eyerium Eye Clinic", address: "388 Gangnam-daero, Gangnam-gu, Seoul, 6-7F" },
    zh: { name: "爱丽姆眼科医院", address: "388 Gangnam-daero, Gangnam-gu, Seoul, 6-7F" },
    mn: { name: "Айриум нүдний эмнэлэг", address: "388 Gangnam-daero, Gangnam-gu, Seoul, 6-7F" },
  },
  118: {
    en: { name: "Eyebaek Eye Clinic", address: "106-4 Dongdeok-ro, Jung-gu, Daegu" },
    zh: { name: "爱百眼科", address: "106-4 Dongdeok-ro, Jung-gu, Daegu" },
    mn: { name: "Айбэк нүдний эмнэлэг", address: "106-4 Dongdeok-ro, Jung-gu, Daegu" },
  },
  119: {
    en: { name: "Eyebom Eye Clinic", address: "9 Baebang-ro 14beon-gil, Asan-si, Chungcheongnam-do, 5F" },
    zh: { name: "爱春眼科医院", address: "9 Baebang-ro 14beon-gil, Asan-si, Chungcheongnam-do, 5F" },
    mn: { name: "Айбом нүдний эмнэлэг", address: "9 Baebang-ro 14beon-gil, Asan-si, Chungcheongnam-do, 5F" },
  },
  120: {
    en: { name: "Eye City Eye Clinic", address: "686 Jungang-daero, Busanjin-gu, Busan, 6F" },
    zh: { name: "爱城眼科", address: "686 Jungang-daero, Busanjin-gu, Busan, 6F" },
    mn: { name: "Ай Сити нүдний эмнэлэг", address: "686 Jungang-daero, Busanjin-gu, Busan, 6F" },
  },
  121: {
    en: { name: "Eyeyu Eye Clinic", address: "84 Samjeon-ro, Songpa-gu, Seoul" },
    zh: { name: "爱侑眼科医院", address: "84 Samjeon-ro, Songpa-gu, Seoul" },
    mn: { name: "Айю нүдний эмнэлэг", address: "84 Samjeon-ro, Songpa-gu, Seoul" },
  },
  122: {
    en: { name: "Eyezone Eye Clinic", address: "152 Beomil-ro, Busanjin-gu, Busan" },
    zh: { name: "爱区眼科医院", address: "152 Beomil-ro, Busanjin-gu, Busan" },
    mn: { name: "Айзон нүдний эмнэлэг", address: "152 Beomil-ro, Busanjin-gu, Busan" },
  },
  123: {
    en: { name: "Eye Plus Eye Clinic", address: "435 Gangnam-daero, Seocho-gu, Seoul, 5F" },
    zh: { name: "爱加眼科", address: "435 Gangnam-daero, Seocho-gu, Seoul, 5F" },
    mn: { name: "Ай Плюс нүдний эмнэлэг", address: "435 Gangnam-daero, Seocho-gu, Seoul, 5F" },
  },
  124: {
    en: { name: "Eins Eye Clinic", address: "778 15-daero, Changwon-si, Masanhoewon-gu, Gyeongsangnam-do, 3F" },
    zh: { name: "艾因斯眼科", address: "778 15-daero, Changwon-si, Masanhoewon-gu, Gyeongsangnam-do, 3F" },
    mn: { name: "Айнс нүдний эмнэлэг", address: "778 15-daero, Changwon-si, Masanhoewon-gu, Gyeongsangnam-do, 3F" },
  },
  125: {
    en: { name: "I'm Ain Eye Clinic", address: "372 Gyeongin-ro, Michuhol-gu, Incheon" },
    zh: { name: "艾姆艾因眼科医院", address: "372 Gyeongin-ro, Michuhol-gu, Incheon" },
    mn: { name: "Айм Айн нүдний эмнэлэг", address: "372 Gyeongin-ro, Michuhol-gu, Incheon" },
  },
  126: {
    en: { name: "Angyeon Eye Clinic", address: "156 Cheongsu-ro, Suseong-gu, Daegu, 3-4F" },
    zh: { name: "安见眼科医院", address: "156 Cheongsu-ro, Suseong-gu, Daegu, 3-4F" },
    mn: { name: "Ангён нүдний эмнэлэг", address: "156 Cheongsu-ro, Suseong-gu, Daegu, 3-4F" },
  },
  127: {
    en: { name: "Alpha Seoul Eye Clinic", address: "152 Pangyoyeok-ro, Seongnam-si, Bundang-gu, Gyeonggi-do, 1F" },
    zh: { name: "阿尔法首尔眼科医院", address: "152 Pangyoyeok-ro, Seongnam-si, Bundang-gu, Gyeonggi-do, 1F" },
    mn: { name: "Альфа Сөүл нүдний эмнэлэг", address: "152 Pangyoyeok-ro, Seongnam-si, Bundang-gu, Gyeonggi-do, 1F" },
  },
  129: {
    en: { name: "Apgujeong Seongmo Eye Clinic", address: "859 Eonju-ro, Gangnam-gu, Seoul, 5F" },
    zh: { name: "狎鸥亭圣母眼科", address: "859 Eonju-ro, Gangnam-gu, Seoul, 5F" },
    mn: { name: "Апгүжон Сонмо нүдний эмнэлэг", address: "859 Eonju-ro, Gangnam-gu, Seoul, 5F" },
  },
  130: {
    en: { name: "Apgujeong (Seocho) Clinic", address: "597 Gangnam-daero, Seocho-gu, Seoul, 3-4F" },
    zh: { name: "狎鸥亭 (瑞草)诊所", address: "597 Gangnam-daero, Seocho-gu, Seoul, 3-4F" },
    mn: { name: "Апгүжон (Сочо) клиник", address: "597 Gangnam-daero, Seocho-gu, Seoul, 3-4F" },
  },
  131: {
    en: { name: "Apgujeong S&B Eye Clinic", address: "842 Nonhyeon-ro, Gangnam-gu, Seoul, 9F" },
    zh: { name: "狎鸥亭S&B眼科医院", address: "842 Nonhyeon-ro, Gangnam-gu, Seoul, 9F" },
    mn: { name: "Апгүжон S&B нүдний эмнэлэг", address: "842 Nonhyeon-ro, Gangnam-gu, Seoul, 9F" },
  },
  132: {
    en: { name: "SNU Eye Clinic (Sinsa-dong)", address: "624 Gangnam-daero, Gangnam-gu, Seoul, 3F" },
    zh: { name: "SNU眼科（新沙洞）", address: "624 Gangnam-daero, Gangnam-gu, Seoul, 3F" },
    mn: { name: "SNU нүдний эмнэлэг (Шинса-дон)", address: "624 Gangnam-daero, Gangnam-gu, Seoul, 3F" },
  },
  133: {
    en: { name: "L&K Mirae Eye Clinic", address: "1590 Bongyeong-ro, Suwon-si, Yeongtong-gu, Gyeonggi-do" },
    zh: { name: "L&K 未来眼科", address: "1590 Bongyeong-ro, Suwon-si, Yeongtong-gu, Gyeonggi-do" },
    mn: { name: "L&K Мирэ нүдний эмнэлэг", address: "1590 Bongyeong-ro, Suwon-si, Yeongtong-gu, Gyeonggi-do" },
  },
  134: {
    en: { name: "MS Eye Clinic (Banpo)", address: "189 Sinbanpo-ro, Seocho-gu, Seoul, 2F" },
    zh: { name: "MS眼科（盘浦）", address: "189 Sinbanpo-ro, Seocho-gu, Seoul, 2F" },
    mn: { name: "MS нүдний эмнэлэг (Банпо)", address: "189 Sinbanpo-ro, Seocho-gu, Seoul, 2F" },
  },
  135: {
    en: { name: "Yonsei Eye Clinic (Jeju)", address: "8675 Iljudong-ro, Seogwipo-si, Jeju-do" },
    zh: { name: "延世眼科（济州）", address: "8675 Iljudong-ro, Seogwipo-si, Jeju-do" },
    mn: { name: "Ёнсэ нүдний эмнэлэг (Жежү)", address: "8675 Iljudong-ro, Seogwipo-si, Jeju-do" },
  },
  136: {
    en: { name: "Yonsei Bareun Eye Clinic", address: "87 Bupyeongmunhwa-ro, Bupyeong-gu, Incheon, 4F" },
    zh: { name: "延世正眼科医院", address: "87 Bupyeongmunhwa-ro, Bupyeong-gu, Incheon, 4F" },
    mn: { name: "Ёнсэ Барын нүдний эмнэлэг", address: "87 Bupyeongmunhwa-ro, Bupyeong-gu, Incheon, 4F" },
  },
  137: {
    en: { name: "Yonsei Bom Eye Clinic", address: "100-1 Misagangbyeondong-ro, Hanam-si, Gyeonggi-do, 6F" },
    zh: { name: "延世春眼科", address: "100-1 Misagangbyeondong-ro, Hanam-si, Gyeonggi-do, 6F" },
    mn: { name: "Ёнсэ Бом нүдний эмнэлэг", address: "100-1 Misagangbyeondong-ro, Hanam-si, Gyeonggi-do, 6F" },
  },
  138: {
    en: { name: "Yonsei Sol Eye Clinic", address: "3 Hwagok-ro 68-gil, Gangseo-gu, Seoul, 6F" },
    zh: { name: "延世松眼科", address: "3 Hwagok-ro 68-gil, Gangseo-gu, Seoul, 6F" },
    mn: { name: "Ёнсэ Сол нүдний эмнэлэг", address: "3 Hwagok-ro 68-gil, Gangseo-gu, Seoul, 6F" },
  },
  139: {
    en: { name: "Yonsei Eye Clinic", address: "103 Sinjeongjungang-ro, Yangcheon-gu, Seoul" },
    zh: { name: "延世眼科医院", address: "103 Sinjeongjungang-ro, Yangcheon-gu, Seoul" },
    mn: { name: "Ёнсэ нүдний эмнэлэг", address: "103 Sinjeongjungang-ro, Yangcheon-gu, Seoul" },
  },
  140: {
    en: { name: "Yonsei Jang Eye Clinic", address: "56 Susaek-ro, Seodaemun-gu, Seoul" },
    zh: { name: "延世张眼科医院", address: "56 Susaek-ro, Seodaemun-gu, Seoul" },
    mn: { name: "Ёнсэ Жан нүдний эмнэлэг", address: "56 Susaek-ro, Seodaemun-gu, Seoul" },
  },
  141: {
    en: { name: "Yonsei Plus Eye Clinic (Seongnam)", address: "168 Seongnam-daero, Seongnam-si, Bundang-gu, Gyeonggi-do, 5F" },
    zh: { name: "延世加眼科（城南）", address: "168 Seongnam-daero, Seongnam-si, Bundang-gu, Gyeonggi-do, 5F" },
    mn: { name: "Ёнсэ Плюс нүдний эмнэлэг (Соннам)", address: "168 Seongnam-daero, Seongnam-si, Bundang-gu, Gyeonggi-do, 5F" },
  },
  142: {
    en: { name: "Yeonsu Kim Eye Clinic", address: "165 Convensia-daero, Yeonsu-gu, Incheon, 5F" },
    zh: { name: "延寿金眼科", address: "165 Convensia-daero, Yeonsu-gu, Incheon, 5F" },
    mn: { name: "Ёнсү Ким нүдний эмнэлэг", address: "165 Convensia-daero, Yeonsu-gu, Incheon, 5F" },
  },
  143: {
    en: { name: "Yeonsu Neul Balgeun Eye Clinic", address: "210 Cheongneung-daero, Yeonsu-gu, Incheon, 3F" },
    zh: { name: "延寿常明眼科", address: "210 Cheongneung-daero, Yeonsu-gu, Incheon, 3F" },
    mn: { name: "Ёнсү Ныл Балгын нүдний эмнэлэг", address: "210 Cheongneung-daero, Yeonsu-gu, Incheon, 3F" },
  },
  144: {
    en: { name: "Yeonsu Smart Eye Clinic", address: "103 Cheongneung-daero, Yeonsu-gu, Incheon, 4F" },
    zh: { name: "延寿智能眼科", address: "103 Cheongneung-daero, Yeonsu-gu, Incheon, 4F" },
    mn: { name: "Ёнсү Смарт нүдний эмнэлэг", address: "103 Cheongneung-daero, Yeonsu-gu, Incheon, 4F" },
  },
  145: {
    en: { name: "Yebon Eye Clinic", address: "78 Jong-ro, Jongro-gu, Seoul, 2F" },
    zh: { name: "艺本眼科医院", address: "78 Jong-ro, Jongro-gu, Seoul, 2F" },
    mn: { name: "Ебон нүдний эмнэлэг", address: "78 Jong-ro, Jongro-gu, Seoul, 2F" },
  },
  146: {
    en: { name: "Yeil Eye Clinic", address: "659 15-daero, Changwon-si, Masanhoewon-gu, Gyeongsangnam-do" },
    zh: { name: "艺一眼科医院", address: "659 15-daero, Changwon-si, Masanhoewon-gu, Gyeongsangnam-do" },
    mn: { name: "Еил нүдний эмнэлэг", address: "659 15-daero, Changwon-si, Masanhoewon-gu, Gyeongsangnam-do" },
  },
  147: {
    en: { name: "Onnuri Smile Eye Clinic", address: "3 Seocho-daero 77-gil, Seocho-gu, Seoul" },
    zh: { name: "温努里微笑眼科", address: "3 Seocho-daero 77-gil, Seocho-gu, Seoul" },
    mn: { name: "Оннүри Смайл нүдний эмнэлэг", address: "3 Seocho-daero 77-gil, Seocho-gu, Seoul" },
  },
  148: {
    en: { name: "Ollim Eye Clinic", address: "546 Nonhyeon-ro, Gangnam-gu, Seoul, 2-5F" },
    zh: { name: "奥林眼科医院", address: "546 Nonhyeon-ro, Gangnam-gu, Seoul, 2-5F" },
    mn: { name: "Оллим нүдний эмнэлэг", address: "546 Nonhyeon-ro, Gangnam-gu, Seoul, 2-5F" },
  },
  149: {
    en: { name: "Olbareun Eye Clinic", address: "145 Gwanggyojungang-ro, Suwon-si, Yeongtong-gu, Gyeonggi-do" },
    zh: { name: "正确眼科医院", address: "145 Gwanggyojungang-ro, Suwon-si, Yeongtong-gu, Gyeonggi-do" },
    mn: { name: "Олбарын нүдний эмнэлэг", address: "145 Gwanggyojungang-ro, Suwon-si, Yeongtong-gu, Gyeonggi-do" },
  },
  150: {
    en: { name: "YB Eye Clinic (Suwon)", address: "181 Gwongwang-ro, Suwon-si, Paldal-gu, Gyeonggi-do" },
    zh: { name: "YB眼科医院（水原）", address: "181 Gwongwang-ro, Suwon-si, Paldal-gu, Gyeonggi-do" },
    mn: { name: "YB нүдний эмнэлэг (Сүвон)", address: "181 Gwongwang-ro, Suwon-si, Paldal-gu, Gyeonggi-do" },
  },
  151: {
    en: { name: "Uri Nun Eye Clinic", address: "92 Jungheung-ro, Pohang-si, Nam-gu, Gyeongsangbuk-do, 2-3F" },
    zh: { name: "我们的眼科", address: "92 Jungheung-ro, Pohang-si, Nam-gu, Gyeongsangbuk-do, 2-3F" },
    mn: { name: "Ури Нүн нүдний эмнэлэг", address: "92 Jungheung-ro, Pohang-si, Nam-gu, Gyeongsangbuk-do, 2-3F" },
  },
  152: {
    en: { name: "Uri Eye Clinic (Songpa-gu)", address: "106 Olympic-ro, Songpa-gu, Seoul" },
    zh: { name: "我们眼科", address: "106 Olympic-ro, Songpa-gu, Seoul" },
    mn: { name: "Ури нүдний эмнэлэг (Сонпха-гү)", address: "106 Olympic-ro, Songpa-gu, Seoul" },
  },
  153: {
    en: { name: "Uri Eye Clinic (Seo-gu)", address: "Dunsan-dong 1034, Seo-gu, Daejeon" },
    zh: { name: "我们眼科医院", address: "Dunsan-dong 1034, Seo-gu, Daejeon" },
    mn: { name: "Ури нүдний эмнэлэг (Со-гү)", address: "Dunsan-dong 1034, Seo-gu, Daejeon" },
  },
  154: {
    en: { name: "Ulsan Balgeun Eye Clinic", address: "274 Samsan-ro, Nam-gu, Ulsan, 6F" },
    zh: { name: "蔚山明亮眼科", address: "274 Samsan-ro, Nam-gu, Ulsan, 6F" },
    mn: { name: "Үлсан Балгын нүдний эмнэлэг", address: "274 Samsan-ro, Nam-gu, Ulsan, 6F" },
  },
  155: {
    en: { name: "Ulsan Seongmo Eye Clinic", address: "201 Samsan-ro, Nam-gu, Ulsan" },
    zh: { name: "蔚山圣母眼科医院", address: "201 Samsan-ro, Nam-gu, Ulsan" },
    mn: { name: "Үлсан Сонмо нүдний эмнэлэг", address: "201 Samsan-ro, Nam-gu, Ulsan" },
  },
  156: {
    en: { name: "Wolbae Inno Eye Clinic", address: "100 Wolbae-ro, Dalseo-gu, Daegu, 2F" },
    zh: { name: "月背伊诺眼科医院", address: "100 Wolbae-ro, Dalseo-gu, Daegu, 2F" },
    mn: { name: "Волбэ Инно нүдний эмнэлэг", address: "100 Wolbae-ro, Dalseo-gu, Daegu, 2F" },
  },
  157: {
    en: { name: "Uval Eye Clinic (Incheon Jung-gu)", address: "90 Uhyeon-ro, Jung-gu, Incheon" },
    zh: { name: "优贝眼科（仁川中区）", address: "90 Uhyeon-ro, Jung-gu, Incheon" },
    mn: { name: "Үвал нүдний эмнэлэг (Инчон Жүн-гү)", address: "90 Uhyeon-ro, Jung-gu, Incheon" },
  },
  158: {
    en: { name: "Yuseong Eye Clinic", address: "105 Gyeryong-ro, Yuseong-gu, Daejeon" },
    zh: { name: "儒城眼科", address: "105 Gyeryong-ro, Yuseong-gu, Daejeon" },
    mn: { name: "Юсон нүдний эмнэлэг", address: "105 Gyeryong-ro, Yuseong-gu, Daejeon" },
  },
  160: {
    en: { name: "Uijeongbu Seoul Eye Clinic", address: "635 Pyeonghwa-ro, Uijeongbu-si, Gyeonggi-do" },
    zh: { name: "议政府首尔眼科", address: "635 Pyeonghwa-ro, Uijeongbu-si, Gyeonggi-do" },
    mn: { name: "Ыйжонбү Сөүл нүдний эмнэлэг", address: "635 Pyeonghwa-ro, Uijeongbu-si, Gyeonggi-do" },
  },
  161: {
    en: { name: "Inno Eye Clinic", address: "260 Wolgok-ro, Dalseo-gu, Daegu, 5F" },
    zh: { name: "伊诺眼科医院", address: "260 Wolgok-ro, Dalseo-gu, Daegu, 5F" },
    mn: { name: "Инно нүдний эмнэлэг", address: "260 Wolgok-ro, Dalseo-gu, Daegu, 5F" },
  },
  162: {
    en: { name: "Lee Seongsu Eye Clinic", address: "863 Jinju-daero, Jinju-si, Gyeongsangnam-do" },
    zh: { name: "李成洙眼科", address: "863 Jinju-daero, Jinju-si, Gyeongsangnam-do" },
    mn: { name: "Ли Сонсү нүдний эмнэлэг", address: "863 Jinju-daero, Jinju-si, Gyeongsangnam-do" },
  },
  163: {
    en: { name: "Lee Eye Hospital", address: "468 Daejong-ro, Jung-gu, Daejeon, 9F" },
    zh: { name: "李眼科医院", address: "468 Daejong-ro, Jung-gu, Daejeon, 9F" },
    mn: { name: "Ли нүдний эмнэлгийн төв", address: "468 Daejong-ro, Jung-gu, Daejeon, 9F" },
  },
  164: {
    en: { name: "Ian Eye Clinic", address: "10 Tongil-ro, Jung-gu, Seoul, 1F" },
    zh: { name: "伊安眼科", address: "10 Tongil-ro, Jung-gu, Seoul, 1F" },
    mn: { name: "Иан нүдний эмнэлэг", address: "10 Tongil-ro, Jung-gu, Seoul, 1F" },
  },
  165: {
    en: { name: "Jamsil Seoul Balgeun Eye Clinic", address: "422 Songpa-daero, Songpa-gu, Seoul, 3F" },
    zh: { name: "蚕室首尔明亮眼科医院", address: "422 Songpa-daero, Songpa-gu, Seoul, 3F" },
    mn: { name: "Жамшил Сөүл Балгын нүдний эмнэлэг", address: "422 Songpa-daero, Songpa-gu, Seoul, 3F" },
  },
  166: {
    en: { name: "Jaylin Eye Clinic", address: "672 Jungang-daero, Busanjin-gu, Busan" },
    zh: { name: "杰琳眼科", address: "672 Jungang-daero, Busanjin-gu, Busan" },
    mn: { name: "Жэйлин нүдний эмнэлэг", address: "672 Jungang-daero, Busanjin-gu, Busan" },
  },
  167: {
    en: { name: "Jeil Yonsei Eye Clinic (Suwon)", address: "3 Paldal-ro, Suwon-si, Paldal-gu, Gyeonggi-do, 2F" },
    zh: { name: "第一延世眼科（水原）", address: "3 Paldal-ro, Suwon-si, Paldal-gu, Gyeonggi-do, 2F" },
    mn: { name: "Жеил Ёнсэ нүдний эмнэлэг (Сүвон)", address: "3 Paldal-ro, Suwon-si, Paldal-gu, Gyeonggi-do, 2F" },
  },
  168: {
    en: { name: "Joeun Saramdeul Seongmo Eye Clinic", address: "315 Wangsimni-ro, Seongdong-gu, Seoul, 7F" },
    zh: { name: "好人们圣母眼科", address: "315 Wangsimni-ro, Seongdong-gu, Seoul, 7F" },
    mn: { name: "Жоын Сарамдыл Сонмо нүдний эмнэлэг", address: "315 Wangsimni-ro, Seongdong-gu, Seoul, 7F" },
  },
  169: {
    en: { name: "Joeun Uisadeul Eye Hospital (Ulsan)", address: "213 Samsan-ro, Nam-gu, Ulsan" },
    zh: { name: "好医生们眼科医院（蔚山）", address: "213 Samsan-ro, Nam-gu, Ulsan" },
    mn: { name: "Жоын Ыйсадыл нүдний эмнэлгийн төв (Үлсан)", address: "213 Samsan-ro, Nam-gu, Ulsan" },
  },
  170: {
    en: { name: "GS Eye Clinic", address: "390 Gangnam-daero, Gangnam-gu, Seoul, 15-16F" },
    zh: { name: "GS眼科", address: "390 Gangnam-daero, Gangnam-gu, Seoul, 15-16F" },
    mn: { name: "GS нүдний эмнэлэг", address: "390 Gangnam-daero, Gangnam-gu, Seoul, 15-16F" },
  },
  171: {
    en: { name: "Jin Eye Clinic", address: "85 Gumijungang-ro, Gumi-si, Gyeongsangbuk-do, 3F" },
    zh: { name: "真眼科", address: "85 Gumijungang-ro, Gumi-si, Gyeongsangbuk-do, 3F" },
    mn: { name: "Жин нүдний эмнэлэг", address: "85 Gumijungang-ro, Gumi-si, Gyeongsangbuk-do, 3F" },
  },
  172: {
    en: { name: "Cheonnunae Eye Clinic", address: "332 Teheran-ro, Gangnam-gu, Seoul, 5F" },
    zh: { name: "初见眼科", address: "332 Teheran-ro, Gangnam-gu, Seoul, 5F" },
    mn: { name: "Чоннүнэ нүдний эмнэлэг", address: "332 Teheran-ro, Gangnam-gu, Seoul, 5F" },
  },
  173: {
    en: { name: "Cheongju Kim Eye Clinic", address: "88 Sajik-daero, Cheongju-si, Seowon-gu, Chungcheongbuk-do" },
    zh: { name: "清州金眼科", address: "88 Sajik-daero, Cheongju-si, Seowon-gu, Chungcheongbuk-do" },
    mn: { name: "Чонжү Ким нүдний эмнэлэг", address: "88 Sajik-daero, Cheongju-si, Seowon-gu, Chungcheongbuk-do" },
  },
  174: {
    en: { name: "Cheongchun Eye Clinic", address: "19 Myeongnyun-ro 103beon-gil, Dongrae-gu, Busan" },
    zh: { name: "青春眼科", address: "19 Myeongnyun-ro 103beon-gil, Dongrae-gu, Busan" },
    mn: { name: "Чончүн нүдний эмнэлэг", address: "19 Myeongnyun-ro 103beon-gil, Dongrae-gu, Busan" },
  },
  175: {
    en: { name: "Choi Eye Clinic", address: "19 Garak-ro, Gimhae-si, Gyeongsangnam-do, 7-8F" },
    zh: { name: "崔眼科医院", address: "19 Garak-ro, Gimhae-si, Gyeongsangnam-do, 7-8F" },
    mn: { name: "Чой нүдний эмнэлэг", address: "19 Garak-ro, Gimhae-si, Gyeongsangnam-do, 7-8F" },
  },
  176: {
    en: { name: "Chuncheon Dream Eye Clinic", address: "98 Bangsong-gil, Chuncheon-si, Gangwon-do" },
    zh: { name: "春川梦想眼科", address: "98 Bangsong-gil, Chuncheon-si, Gangwon-do" },
    mn: { name: "Чунчон Дрийм Ай нүдний эмнэлэг", address: "98 Bangsong-gil, Chuncheon-si, Gangwon-do" },
  },
  177: {
    en: { name: "Chungju Seongmo Eye Clinic", address: "33 Jungang-ro, Chungju-si, Chungcheongbuk-do, 1F" },
    zh: { name: "忠州圣母眼科", address: "33 Jungang-ro, Chungju-si, Chungcheongbuk-do, 1F" },
    mn: { name: "Чунжү Сонмо нүдний эмнэлэг", address: "33 Jungang-ro, Chungju-si, Chungcheongbuk-do, 1F" },
  },
  178: {
    en: { name: "Clear Seoul Eye Clinic", address: "17 Seocho-daero 77-gil, Seocho-gu, Seoul, 6F" },
    zh: { name: "清晰首尔眼科", address: "17 Seocho-daero 77-gil, Seocho-gu, Seoul, 6F" },
    mn: { name: "Клиар Сөүл нүдний эмнэлэг", address: "17 Seocho-daero 77-gil, Seocho-gu, Seoul, 6F" },
  },
  179: {
    en: { name: "Clear Eye Clinic", address: "181-26 Jije-dongsak 2-ro, Pyeongtaek-si, Gyeonggi-do, 4-5F" },
    zh: { name: "清晰眼科医院", address: "181-26 Jije-dongsak 2-ro, Pyeongtaek-si, Gyeonggi-do, 4-5F" },
    mn: { name: "Клиар нүдний эмнэлэг", address: "181-26 Jije-dongsak 2-ro, Pyeongtaek-si, Gyeonggi-do, 4-5F" },
  },
  180: {
    en: { name: "Time Eye Clinic", address: "387 Gyeongin-ro, Guro-gu, Seoul, 5F" },
    zh: { name: "时光眼科", address: "387 Gyeongin-ro, Guro-gu, Seoul, 5F" },
    mn: { name: "Тайм нүдний эмнэлэг", address: "387 Gyeongin-ro, Guro-gu, Seoul, 5F" },
  },
  181: {
    en: { name: "Tae Eye Clinic (Nowon)", address: "1547 Dongil-ro, Nowon-gu, Seoul" },
    zh: { name: "泰眼科（芦原）", address: "1547 Dongil-ro, Nowon-gu, Seoul" },
    mn: { name: "Тэ нүдний эмнэлэг (Новон)", address: "1547 Dongil-ro, Nowon-gu, Seoul" },
  },
  182: {
    en: { name: "Fatima Eye Clinic", address: "320 Woni-daero, Changwon-si, Seongsan-gu, Gyeongsangnam-do, 4F" },
    zh: { name: "法蒂玛眼科", address: "320 Woni-daero, Changwon-si, Seongsan-gu, Gyeongsangnam-do, 4F" },
    mn: { name: "Фатима нүдний эмнэлэг", address: "320 Woni-daero, Changwon-si, Seongsan-gu, Gyeongsangnam-do, 4F" },
  },
  184: {
    en: { name: "First Samsung Eye Clinic", address: "22 Seocho-daero 78-gil, Seocho-gu, Seoul, 5F" },
    zh: { name: "第一三星眼科", address: "22 Seocho-daero 78-gil, Seocho-gu, Seoul, 5F" },
    mn: { name: "Фөрст Самсун нүдний эмнэлэг", address: "22 Seocho-daero 78-gil, Seocho-gu, Seoul, 5F" },
  },
  185: {
    en: { name: "First Seongmo Eye Clinic", address: "1405 Dongil-ro, Nowon-gu, Seoul, 8F" },
    zh: { name: "第一圣母眼科", address: "1405 Dongil-ro, Nowon-gu, Seoul, 8F" },
    mn: { name: "Фөрст Сонмо нүдний эмнэлэг", address: "1405 Dongil-ro, Nowon-gu, Seoul, 8F" },
  },
  186: {
    en: { name: "First Eye Clinic", address: "5 Gudeok-ro, Jung-gu, Busan, 6-7F" },
    zh: { name: "第一眼科医院", address: "5 Gudeok-ro, Jung-gu, Busan, 6-7F" },
    mn: { name: "Фөрст нүдний эмнэлэг", address: "5 Gudeok-ro, Jung-gu, Busan, 6-7F" },
  },
  187: {
    en: { name: "Pureun Eye Clinic (Jeonju)", address: "660 Baekje-daero, Jeonju-si, Deokjin-gu, Jeollabuk-do" },
    zh: { name: "青翠眼科（全州）", address: "660 Baekje-daero, Jeonju-si, Deokjin-gu, Jeollabuk-do" },
    mn: { name: "Пүрын нүдний эмнэлэг (Чонжү)", address: "660 Baekje-daero, Jeonju-si, Deokjin-gu, Jeollabuk-do" },
  },
  188: {
    en: { name: "Hana Seoul Eye Clinic", address: "181 Gilju-ro, Bucheon-si, Wonmi-gu, Gyeonggi-do, 2F" },
    zh: { name: "哈娜首尔眼科医院", address: "181 Gilju-ro, Bucheon-si, Wonmi-gu, Gyeonggi-do, 2F" },
    mn: { name: "Хана Сөүл нүдний эмнэлэг", address: "181 Gilju-ro, Bucheon-si, Wonmi-gu, Gyeonggi-do, 2F" },
  },
  189: {
    en: { name: "Haneul Eye Clinic (Songdo)", address: "14 Convensia-daero 130beon-gil, Yeonsu-gu, Incheon" },
    zh: { name: "天空眼科（松岛）", address: "14 Convensia-daero 130beon-gil, Yeonsu-gu, Incheon" },
    mn: { name: "Ханыл нүдний эмнэлэг (Сондо)", address: "14 Convensia-daero 130beon-gil, Yeonsu-gu, Incheon" },
  },
  190: {
    en: { name: "Haneul Eye Clinic", address: "509 Gangnam-daero, Seocho-gu, Seoul, 10F" },
    zh: { name: "天空眼科医院", address: "509 Gangnam-daero, Seocho-gu, Seoul, 10F" },
    mn: { name: "Ханыл нүдний эмнэлэг", address: "509 Gangnam-daero, Seocho-gu, Seoul, 10F" },
  },
  191: {
    en: { name: "High View Eye Clinic", address: "767-1 Gaya-daero, Busanjin-gu, Busan, 2-3F" },
    zh: { name: "海景眼科", address: "767-1 Gaya-daero, Busanjin-gu, Busan, 2-3F" },
    mn: { name: "Хай Вью нүдний эмнэлэг", address: "767-1 Gaya-daero, Busanjin-gu, Busan, 2-3F" },
  },
  192: {
    en: { name: "High Eye Clinic", address: "119 Dosan-daero, Gangnam-gu, Seoul, 3F" },
    zh: { name: "海眼科", address: "119 Dosan-daero, Gangnam-gu, Seoul, 3F" },
    mn: { name: "Хай нүдний эмнэлэг", address: "119 Dosan-daero, Gangnam-gu, Seoul, 3F" },
  },
  193: {
    en: { name: "Hangil Eye Hospital", address: "35 Bupyeong-daero, Bupyeong-gu, Incheon" },
    zh: { name: "韩吉眼科医院", address: "35 Bupyeong-daero, Bupyeong-gu, Incheon" },
    mn: { name: "Хангил нүдний эмнэлгийн төв", address: "35 Bupyeong-daero, Bupyeong-gu, Incheon" },
  },
  194: {
    en: { name: "Hanbit Eye Clinic", address: "2109 Dalgubeol-daero, Jung-gu, Daegu, 3F" },
    zh: { name: "韩光眼科", address: "2109 Dalgubeol-daero, Jung-gu, Daegu, 3F" },
    mn: { name: "Ханбит нүдний эмнэлэг", address: "2109 Dalgubeol-daero, Jung-gu, Daegu, 3F" },
  },
  195: {
    en: { name: "Hyean Seoul Eye Clinic", address: "528 Teheran-ro, Gangnam-gu, Seoul, 4F" },
    zh: { name: "慧眼首尔眼科", address: "528 Teheran-ro, Gangnam-gu, Seoul, 4F" },
    mn: { name: "Хеан Сөүл нүдний эмнэлэг", address: "528 Teheran-ro, Gangnam-gu, Seoul, 4F" },
  },
  196: {
    en: { name: "Hyo Eye Clinic", address: "16 Daedeok-daero 175beon-gil, Seo-gu, Daejeon, 9F" },
    zh: { name: "孝眼科医院", address: "16 Daedeok-daero 175beon-gil, Seo-gu, Daejeon, 9F" },
    mn: { name: "Хё нүдний эмнэлэг", address: "16 Daedeok-daero 175beon-gil, Seo-gu, Daejeon, 9F" },
  },
  197: {
    en: { name: "Healing Eye Clinic", address: "470 Gangnam-daero, Gangnam-gu, Seoul, 10-11F" },
    zh: { name: "疗愈眼科", address: "470 Gangnam-daero, Gangnam-gu, Seoul, 10-11F" },
    mn: { name: "Хийлин нүдний эмнэлэг", address: "470 Gangnam-daero, Gangnam-gu, Seoul, 10-11F" },
  },
};
